<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="purchaseReceiveDetails"
        @select="selectHandle"
        @addOrEdit="addEditHandle"
        @reset="resetHandle"
        @delete="deleteHandle">
      <template slot="otherBtn">
        <el-button
            v-if="printAuth"
            :loading="printLoading"
            :disabled="!selection.length"
            type="primary"
            @click="checkNote">
          打印送货单
        </el-button>
        <el-button
            v-if="aogAuth"
            :loading="scanLoading"
            :disabled="!selection.length"
            type="success"
            @click="aOGScan">
          到货扫描
        </el-button>
        <el-button
            v-if="inStockAuth"
            :loading="inStoreScanLoading"
            :disabled="!selection.length"
            type="success"
            @click="inStoreScan">
          入库扫描
        </el-button>
        <el-button
            v-if="zfConfirmAuth"
            :loading="inStoreScanLoading"
            :disabled="!selection.length"
            type="success"
            @click="straightConfirm">
          直发确认
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="subAuth" type="success" :disabled="scope.row.status !== 0" @click="submit(scope.row.mastPKID)">提交</el-button>
        <el-button v-if="rollAuth" type="primary" :disabled="scope.row.status !== 10" @click="rollBack(scope.row.mastPKID)">退回</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购订单：">
            <el-input
                v-model.trim="filter.purchaseOrderNo"
                type="textarea"
                autosize
                placeholder="请输入采购单号"
                clearable/>
          </el-form-item>
          <el-form-item label="送货单号">
            <el-input
                v-model.trim="filter.no"
                type="textarea"
                autosize
                placeholder="请输入送货单号"
                clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="旧料号">
            <el-input v-model.trim="filter.mappingMaterialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购员" clearable/>
          </el-form-item>
          <el-form-item label="物料描述">
            <el-input v-model.trim="filter.sAPMaterialName" placeholder="请输入物料描述" clearable/>
          </el-form-item>
          <el-form-item label="送货单状态">
            <el-select v-model.trim="filter.status" placeholder="请选择状态">
              <el-option label="全部" :value="-1"/>
              <el-option label="待提交" :value="0"/>
              <el-option label="已提交" :value="10"/>
              <el-option label="已到货" :value="11"/>
              <el-option label="已质检" :value="30"/>
              <el-option label="已入库" :value="50"/>
              <el-option label="退回" :value="98"/>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入名称" clearable/>
          </el-form-item>
          <el-form-item label="SAP物料凭证">
            <el-input v-model.trim="filter.sapVoucher" placeholder="请输入SAP物料凭证" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createDateChange"
            />
          </el-form-item>
          <el-form-item label="到货日期">
            <el-date-picker
                v-model="arriveDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="arriveDateChange"
            />
          </el-form-item>
          <el-form-item label="入库日期">
            <el-date-picker
                v-model="instockDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="instockDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <purchase-receive-edit ref="purchaseReceiveEdit" :is-yh="isYH" @save-success="loadData"/>
    <delivery-in-stock-detail ref="deliveryInStockDetail" @save-success="loadData"/>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="noteDialogVisible"
        :close-on-click-modal="false"
        title="打印参数配置">
      <el-form
          ref="form"
          :model="filter"
          class="form"
          label-width="120px">
        <el-form-item label="打印备注" prop="notePrint">
          <el-select v-model="filter.notePrint" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="noteDialogVisible = false">取消</el-button>
        <el-button :loading="printLoading" type="primary" @click="printPurchaseReceive(filter.notePrint)">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import PurchaseReceiveEdit from "./PurchaseReceiveEdit.vue";
  import DeliveryInStockDetail from "@/views/PurchaseOrderManager/PurchaseReceiveList/DeliveryInStockDetail";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "PurchaseReceiveList",
    components: {DeliveryInStockDetail, PurchaseReceiveEdit, viewTable},
    data() {
      return {
        limits: {
          editAuth: this.$auth(439),
          delAuth: this.$auth(445),
        },
        printAuth: this.$auth(446),
        aogAuth: this.$auth(447),
        inStockAuth: this.$auth(448),
        zfConfirmAuth: this.$auth(449),
        rollAuth: this.$auth(442),
        subAuth: this.$auth(441),
        rollBackAuth:this.$auth(953),
        printLoading: false,
        scanLoading: false,
        inStoreScanLoading: false,
        noteDialogVisible:false,
        isYH: false, // 是否是通过要货创建的
        filter: {
          purchaseOrderNo: "",
          no: "",
          supplierName: "",
          materialNo: "",
          sAPMaterialName: "",
          sapVoucher: "",
          status: -1,
          notePrint: true,
          arrivedTimeBegin: "",
          arrivedTimeEnd: "",
          createDateBegin: "",
          createDateEnd: "",
          inStockTimeBegin: "",
          inStockTimeEnd: "",
          buyUserName:loginUtil.getName(),
        },
        ids: [],
        purchaseReceiveNos: [],
        selection: [],
        createDate: "",
        arriveDate: "",
        instockDate: "",
        columnsProperty: [
          {
 
            key: "purchaseReceiveNO",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.purchaseReceiveEdit.open(params.row.mastPKID, true,false);
                    },
                  },
                },
                params.row.purchaseReceiveNO,
              );
            },
          },
          {
            key: "rowIndex",
            width: 70,
            align: "center",
          },
          {
            key: "statusName",
            width: 140,
            align: "center",
          },
          {
            key: "sapMaterialNo",
            width: 120,
            align: "center",
          },
          {
            key: "sapMaterialName",
            width: 200,
            align: "center",
          },
          {
            key: "supplierName",
            width: 200,
            align: "center",
          },
          {
            key: "evaluate",
            width: 150,
            align: "center",
          },

          {
            key: "poDetailRowNo",
            width: 100,
            align: "center",
          },
          {
            key: "buyUserName",
            width: 100,
            align: "center",
          },
          {
            key: "requireDeliveryDate",
            width: 120,
            align: "center",
          },
          {
            key: "quantity",
            width: 100,
            align: "center",
          },
          {
            key: "instockQuantity",
            width: 100,
            align: "center",
          },
          {
            key: "straightMark",
            width: 100,
            align: "center",
          },
          {
            key: "createdTime",
            width: 120,
            align: "center",
          },
          {
            key: "arrivedTime",
            width: 120,
            align: "center",
          },
          {
            key: "inStockTime",
            width: 120,
            align: "center",
          },
          {
            key: "sapVoucher",
            width: 120,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 300,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
        this.ids = [];
        this.purchaseReceiveNos = [];
        for (let item of this.selection) {
          this.ids.push(item.mastPKID);
          this.purchaseReceiveNos.push(item.purchaseReceiveNO);
        }
      },

      addEditHandle(row) {
        this.isYH = !!row.purchasePlanId; // purchasePlanId有这个id，则是从要货创建的发货单，查询明细列表时，要查要货的列表
        this.$refs.purchaseReceiveEdit.open(row.mastPKID,null,true);
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return false;
        } else {
          return true;
        }
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        console.log(row);
        this.$http.get("basic", `purchaseReceives/deletePurchaseReceive/${row.mastPKID}`).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      arriveDateChange(value) {
        if (value) {
          this.filter.arrivedTimeBegin = value[0];
          this.filter.arrivedTimeEnd = value[1];
        } else {
          this.filter.arrivedTimeBegin = "";
          this.filter.arrivedTimeEnd = "";
        }
      },

      createDateChange(value) {
        if (value) {
          this.filter.createDateBegin = value[0];
          this.filter.createDateEnd = value[1];
        } else {
          this.filter.createDateBegin = "";
          this.filter.createDateEnd = "";
        }
      },

      instockDateChange(value) {
        if (value) {
          this.filter.inStockTimeBegin = value[0];
          this.filter.inStockTimeEnd = value[1];
        } else {
          this.filter.inStockTimeBegin = "";
          this.filter.inStockTimeEnd = "";
        }
      },


      resetHandle(filter) {
        this.filter = filter;
      },

      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "purchaseReceives/submitPurchaseReceive/" + pkid).then((resp) => {
            if (resp.success) {
              this.$message.success("操作成功");
              this.loadData();
            }
          });
        });
      },

      rollBack(id) {
        this.$confirm("确定退回吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "purchaseReceives/rejectPurchaseReceiveByPurchaser/" + id).then((resp) => {
            if (resp.success) {
              this.$message.success("退回成功");
              this.loadData();
            }
          });
        });
      },

      // 打印发货单
      checkNote() {
        if (this.ids.length === 0) {
          this.$message.error("请至少选择一条需要打印的送货单");
          return;
        }
        this.noteDialogVisible = true;
      },

      printPurchaseReceive(notePrint) {
        console.log(notePrint);
        if (this.selection.find((item) => item.status === 0)) {
          this.$confirm("确认打印吗?打印后的订单无法修改", "提示", { type: "warning" }).then(() => {
            this.printLoading = true;
            this.$http
              .postForFile("basic", "purchaseReceives/printPurchaseReceiveVO/"+notePrint, this.ids)
              .then((res) => {
                console.log(res);
                let blob = new Blob([res.data], {type: "application/pdf"});
                let pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl);
                this.printLoading = false;
                this.selection = [];
                this.ids = [];
                this.getList();
              }).catch(() => {
                this.$refs.vmTable.clearSelection();
                this.printLoading = false;
              });
          });
        } else {
          this.printLoading = true;
          this.$http
            .postForFile("basic", "purchaseReceives/printPurchaseReceiveVO/"+notePrint, this.ids)
            .then((res) => {
              let blob = new Blob([res.data], {type: "application/pdf"});
              let pdfUrl = window.URL.createObjectURL(blob);
              window.open(pdfUrl);
              this.printLoading = false;
              this.selection =[];
              this.ids = [];
              this.getList();
            }).catch(() => {
              this.$refs.vmTable.clearSelection();
              this.printLoading = false;
            });
        }
      },
      //到货扫描
      aOGScan() {
        if (this.purchaseReceiveNos.length === 0) {
          this.$message.error("请至少选择一条需要扫描的送货单");
          return;
        }
        for (let item of this.selection) {
          if (item.status!==10) {
            this.$message.error("请选择已提交的送货单");
            return;
          }
        }
        
        this.$confirm("确定要进行到货扫描吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.scanLoading = true;
          this.$http
            .post("basic", "purchaseReceives/aogScan", this.purchaseReceiveNos)
            .then((res) => {
              if (res.success) {
                console.log(res);
                this.$message.success("扫描成功");
                this.purchaseReceiveNos = [];
                this.loadData();
              }
            }).finally(()=>{
              this.purchaseReceiveNos = [];
              this.scanLoading = false;
            });
        });
      },

      //入库扫描
      inStoreScan() {
        if (!this.purchaseReceiveNos.length) {
          this.$message.error("请选择一条需要扫描的送货单");
          return;
        }
        const WrongStatusList = this.selection.filter(item=> item.status === 50);
        var message = "";
        if(WrongStatusList.length > 0) {
          WrongStatusList.forEach((item)=>{
            message += "采购单号：" + item.evaluate + ",行号：" + item.podetailRowNO + "为已入库状态无法扫描" + "<br/>";
          });
          this.$message({
            message:message,
            type:"error",
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        this.$refs.deliveryInStockDetail.open(this.purchaseReceiveNos[0]);
      },

      straightConfirm() {
        if (this.selection.length!==1) {
          this.$message.error("请选择一条数据");
        }
        this.inStoreScanLoading=true;
        let pkid=this.selection[0].mastPKID;
        console.log(this.selection);
        this.$http.get("basic",`purchaseReceives/straightConfirm/${pkid}`)
          .then((resp)=>{
            if (resp.success) {
              this.$message.success("直发成功");
            }
          }).finally(()=>{
            this.loadData();
            this.inStoreScanLoading=false;
          });
      },
    },
  };
</script>
